module.exports = __webpack_public_path__ + "img/chadle_adv_19.e96ad308.png";